import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../../lib/shared/validators";

export const validatorPurchaseOrderItem = v.object({
  purchaseOrderId: v.id("purchase_orders"),
  productId: v.optional(v.id("products")),
  name: v.string(),
  description: v.optional(v.string()),
  quantity: v.number(),
  // Cantidad ya recibida (para recepciones parciales). 0 hasta la primera recepcion.
  quantityReceived: v.optional(v.number()),
  unitPrice: v.number(), // costo de compra
  unit: v.string(),
  taxRate: v.number(),
  subtotal: v.number(),
  taxAmount: v.number(),
  totalAmount: v.number(),
  sortOrder: v.optional(v.number()),
  productCode: v.optional(v.string()),
  internalControl,
});

export const purchase_orders_items = defineTable(validatorPurchaseOrderItem)
  .index("by_purchase_order", ["purchaseOrderId"])
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_product", ["productId"]);
